document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.buy-now-btn');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;                // must be a VARIANT id
  const qty       = parseInt(btn.dataset.qty || '1', 10);
  const sellingPlan = btn.dataset.sellingPlanId || null;  // optional (subscriptions)

  if (!variantId || isNaN(Number(variantId))) {
    console.error('Missing/invalid variantId on .buy-now-btn');
    alert('Variant not selectable. Please choose options.');
    return;
  }

  btn.disabled = true;

  try {
    const body = { id: Number(variantId), quantity: qty };
    if (sellingPlan) body.selling_plan = sellingPlan;

    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });

    const data = await res.json();

    if (!res.ok) {
      // Shopify returns {status: 422, message/description: "..."}
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    // slight micro-delay helps on some themes
    setTimeout(() => {
      window.location.assign(window.Shopify.routes.root + 'checkout');
    }, 50);

  } catch (err) {
    console.error(err);
    alert(err.message || 'Something went wrong, please try again.');
    btn.disabled = false;
  }
});



document.addEventListener("click", function(e) {
  if (e.target.classList.contains("ajax-add-to-cart")) {
    e.preventDefault();

    let variantId = e.target.getAttribute("data-variant-id");

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Added to cart:", data);

      // 🔄 Cart count update
      fetch(window.Shopify.routes.root + "cart.js")
        .then(res => res.json())
        .then(cart => {
          let countElem = document.querySelector(".cart-count");
          if (countElem) countElem.textContent = cart.item_count;
        });

      // 🚀 n open karna hai to yaha apka plugin ka function call karein
    })
    .catch(error => console.error("Error:", error));
  }
});
